import { styled } from '@mui/material';

export const StyledContainer = styled('div')<{ showBorderBox: boolean }>(({ showBorderBox }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  ...(showBorderBox && {
    border: '1px solid #252a36',
    borderRadius: 4,
    padding: '7px 4px',
    backgroundColor: '#fff',
    boxSizing: 'border-box',
    height: 56,
  }),
}));
